(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5540],{

/***/ 66678:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(85990);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ 55540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ MultiImageWithMessage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_nl2br__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31503);
/* harmony import */ var _hooks_useWidth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9177);
/* harmony import */ var _packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59848);
/* harmony import */ var _shared_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74333);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56068);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);







function MultiImageWithMessage(param) {
    var image = param.image, title = param.title, subtitle = param.subtitle, items = param.items, _ssrImages = param.ssrImages, ssrImages = _ssrImages === void 0 ? [] : _ssrImages;
    var viewportWidth = (0,_hooks_useWidth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)();
    var isSmall = viewportWidth <= 768;
    var imagePadding = 20;
    var slides = items.map(function(item, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().item),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "row",
                children: [
                    index % 2 === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-xs-12 col-sm-6 col-md-5",
                        children: item.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            fileId: item.image._id,
                            alt: "",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().image),
                            width: isSmall ? 360 : 1600,
                            style: {
                                maxWidth: "calc(100% - ".concat(imagePadding, "px)"),
                                padding: "".concat(imagePadding, "px")
                            },
                            ssrImage: ssrImages[index]
                        })
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "col-xs-12 col-sm-6 col-md-7",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().itemTitle),
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().text),
                                children: (0,_helpers_misc_nl2br__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(item.text)
                            })
                        ]
                    }),
                    index % 2 === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-xs-12 col-sm-6 col-md-5",
                        children: item.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            fileId: item.image._id,
                            alt: "",
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().image),
                            width: viewportWidth - imagePadding,
                            style: {
                                maxWidth: "calc(100% - ".concat(imagePadding, "px)"),
                                padding: "".concat(imagePadding, "px")
                            },
                            ssrImage: ssrImages[index]
                        })
                    }) : null
                ]
            })
        }, index);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        size: "medium",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().container),
            children: [
                title || subtitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().header),
                    children: [
                        title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().title),
                            children: title
                        }) : null,
                        subtitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: subtitle
                        }) : null
                    ]
                }) : null,
                slides
            ]
        })
    });
};


/***/ }),

/***/ 74333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_SuspenseLoading_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53762);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90257);
/* harmony import */ var _hooks_useResizedImageURL__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25447);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






function Image(param) {
    var alt = param.alt, fileId = param.fileId, scale = param.scale, width = param.width, height = param.height, resizeMode = param.resizeMode, background = param.background, format = param.format, style = param.style, className = param.className, _isDiv = param.isDiv, isDiv = _isDiv === void 0 ? false : _isDiv, ssrImage = param.ssrImage;
    var imageResizeProps = _objectSpread({
        fileId: fileId
    }, scale && {
        scale: scale
    }, width && {
        width: width
    }, height && {
        height: height
    }, resizeMode && {
        resizeMode: resizeMode
    }, background && {
        background: background
    }, format && {
        format: format
    });
    var url = (0,_hooks_useResizedImageURL__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(imageResizeProps, {
        partial: true
    });
    var imageUrl = url ? url : ssrImage === null || ssrImage === void 0 ? void 0 : ssrImage.resizedURL;
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)() && !(ssrImage === null || ssrImage === void 0 ? void 0 : ssrImage.resizedURL)) {
        console.warn("Could not fetch image while doing SSR. This should be fixed for an optimized experience");
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SuspenseLoading_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
    }
    var imageMarkupProps = _objectSpread({}, className && {
        className: className
    }, style && {
        style: style
    });
    if (!isDiv) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", _objectSpread({
            src: imageUrl,
            alt: alt
        }, imageMarkupProps));
    }
    var divMarkupProps = _objectSpread({}, className && {
        className: className
    }, {
        style: _objectSpread({
            backgroundImage: "url(".concat(imageUrl, ")")
        }, style && {
            style: style
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpread({
        "aria-label": alt
    }, divMarkupProps));
};
Image.propTypes = {
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
    fileId: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired),
    scale: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),
    resizeMode: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    background: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    format: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    style: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().object),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    isDiv: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool)
};


/***/ }),

/***/ 6909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HasWebpSupport; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

var result = null;
// https://stackoverflow.com/questions/5573096/detecting-webp-support
function HasWebpSupport() {
    if (result !== null) {
        return result;
    }
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) return true;
    result = false;
    var elem = document.createElement("canvas");
    if (elem.getContext && elem.getContext("2d")) {
        // was able or not to get WebP representation
        try {
            result = elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
        } catch (e) {
            result = false;
        }
    }
    // very old browser like IE 8, canvas not supported
    return result;
};


/***/ }),

/***/ 31503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Nl2br; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Nl2br(text) {
    return text.split("\n").map(function(line, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                line,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
            ]
        }, index);
    });
};


/***/ }),

/***/ 25447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useResizedImageURL; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_hasWebpSupport__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6909);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90257);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50456);
/* harmony import */ var lodash_clone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66678);
/* harmony import */ var lodash_clone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_clone__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _useLocalStorageState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54501);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getResizedImage(\n        $fileId: ID\n        $scale: Float\n        $width: Float\n        $height: Float\n        $resizeMode: ID\n        $background: String\n        $format: String\n      ) {\n        image(fileId: $fileId) {\n          _id\n          resizedURL(\n            scale: $scale\n            width: $width\n            height: $height\n            resizeMode: $resizeMode\n            background: $background\n            format: $format\n          )\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function useResizedImageURL(opt) {
    var queryOpts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var options = lodash_clone__WEBPACK_IMPORTED_MODULE_1___default()(opt);
    if (options.format !== "jpeg" && (0,_helpers_misc_hasWebpSupport__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()) {
        options.format = "webp";
    }
    var cacheKey = "resizedImage.".concat(JSON.stringify(options));
    var cachedResult = (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)() ? null : (0,_useLocalStorageState__WEBPACK_IMPORTED_MODULE_2__/* .localStorageGetItem */ .G)(cacheKey);
    var image = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useApolloQuery */ .Zu)(_objectSpread({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_5__["default"])(_templateObject()),
        variables: options,
        omit: !!cachedResult || !options.fileId || (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)()
    }, queryOpts)).image;
    if (!options.fileId) return null;
    if (cachedResult) return cachedResult;
    if (!image) return null;
    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(cacheKey, image.resizedURL);
    return image.resizedURL;
};


/***/ }),

/***/ 9177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ useWidth; }
/* harmony export */ });
/* unused harmony exports DEFAULT_DESKTOP_WIDTH, DEFAULT_MOBILE_WIDTH */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var _providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95078);




var DEFAULT_DESKTOP_WIDTH = 1920;
var DEFAULT_MOBILE_WIDTH = 360;
function useWidth() {
    var ssrMobileOrDesktop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    var ssrWidth = ssrMobileOrDesktop === "mobile" ? DEFAULT_MOBILE_WIDTH : DEFAULT_DESKTOP_WIDTH;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)() ? ssrWidth : window.innerWidth), width = ref[0], setWidth = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = function handler() {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handler);
        return function() {
            window.removeEventListener("resize", handler);
        };
    }, []);
    return width !== null && width !== void 0 ? width : ssrWidth;
};


/***/ }),

/***/ 95078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext("desktop"));


/***/ }),

/***/ 56068:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3geqSBYqnGs2wxZsezFK1C","col-xs-12":"_3u9iFigsjazHvMiJRWCPC-","header":"_1CJNrvs5vToTYirXh06OmK","title":"_1NS-fRp1wMm-QNvFW7rpKi appSubtitle","image":"QeXYGSHGrSeB_kDe17HRe","itemTitle":"_3GfowblsaLLBWNPjwgW4c7 appSubtitle","text":"uqqWtclkPqAzCKUFdCdVr","item":"_2eUSZTiMz4f_buF7qFWlJL"};

/***/ })

}]);